'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gxg-bg flex items-center justify-center p-6">
      <div className="text-center">
        <div className="font-display font-black text-8xl gxg-gradient-text mb-4">404</div>
        <h1 className="font-display font-bold text-2xl text-white mb-3">Level Not Found</h1>
        <p className="text-white/50 mb-6">This page doesn&apos;t exist in the GXG vault.</p>
        <Link href="/home" className="btn-gxg-primary px-6 py-3 rounded-lg text-sm inline-block">
          Return to Home Base
        </Link>
      </div>
    </div>
  );
}